import React from 'react';
import './LargeDatasetModal.css';

interface LargeDatasetModalProps {
  isOpen: boolean;
  entryCount: number;
  onClose: () => void;
}

export const LargeDatasetModal: React.FC<LargeDatasetModalProps> = ({
  isOpen,
  entryCount,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <div className="large-dataset-overlay" onClick={onClose} role="presentation">
      <div
        className="large-dataset-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="large-dataset-title"
      >
        <div className="large-dataset-header">
          <h3 id="large-dataset-title" className="large-dataset-title">
            Large dataset loaded
          </h3>
        </div>

        <div className="large-dataset-content">
          <p className="large-dataset-message">
            You&apos;ve loaded{' '}
            <strong>{entryCount.toLocaleString()}</strong> entries. With files
            this size, charts, reports, and filters can feel slower — and
            sometimes less responsive.
          </p>
        </div>

        <div className="large-dataset-actions">
          <button
            type="button"
            className="large-dataset-button large-dataset-button--primary"
            onClick={onClose}
            autoFocus
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};
